const state = () => ({
  questionlist:null,
  questionlists:[],
  inputfields:0,
  sections:0,
});
const getters = {
  questionlist(state){
    return state.questionlist
  },
  questionlists(state){
    return state.questionlists
  },
  inputfields(state){
    return state.inputfields
  },
  sections(state){
    return state.sections
  },
};
const  mutations =  {
  SET_QUESTIONLIST(state,data){
    state.questionlist = data
  },
  SET_QUESTIONLISTS(state,data){
    state.questionlists = data
  },
  SET_INPUTFIELDS(state,data){
    state.inputfields = data
  },
  SET_SECTIONS(state,data){
    state.sections = data
  },
};
const actions =  {
  setQuestionlist({commit},data)  {
    commit("SET_QUESTIONLIST",data)
  },
  setQuestionlists({commit},data)  {
    commit("SET_QUESTIONLISTS",data)
  },
  setInputfields({commit},data)  {
    commit("SET_INPUTFIELDS",data)
  },
  setSections({commit},data)  {
    commit("SET_SECTIONS",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

